import { useEffect, useMemo, useState } from "react";
import { AccountListItem } from "../types";
import { useSelectUpdatedCompany } from "./useSelectUpdatedCompany";
import { useAppDispatch } from "./useReduxHooks";
import { removeUpdatedCompany } from "../features/companySlice";

type Props = {
  data: AccountListItem;
};

export const useUpdateAccountData = ({ data }: Props) => {
  const dispatch = useAppDispatch();
  const [isUpdatedData, setIsUpdatedData] = useState<boolean>(false);
  const [currentData, setCurrentData] = useState<AccountListItem>(data);
  const updatedCompany = useSelectUpdatedCompany(data.id);

  useEffect(() => {
    setIsUpdatedData(false);
    dispatch(removeUpdatedCompany(data.id));
    setCurrentData(data);
  }, [data]);

  useEffect(() => {
    updatedCompany && setIsUpdatedData(true);
  }, [updatedCompany]);

  return useMemo(
    () => (isUpdatedData ? { ...currentData, ...updatedCompany } : currentData),
    [isUpdatedData, updatedCompany, currentData],
  );
};
